import React from "react";
import BACENTable from "./BACENTable/BACENTable";

export default function BACENCard(props) {
    const { bacen_data } = props
    const hasSource = Object.keys(bacen_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                BACEN - Match encontrado
            </p>
            <BACENTable bacen_data={bacen_data.source} />
        </div>
    )
}
